import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";

import "./index.css";
import "./services/i18n";
import App from "./App";
import { store } from "./store/store";
import { appTheme } from "./themes/theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ThemeProvider theme={appTheme}>
                <CssBaseline />
                <HashRouter>
                    <App />
                </HashRouter>
            </ThemeProvider>
        </Provider>
    </React.StrictMode>
);
